import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-action';

class UpdateUser extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    return html`
      <bn-action
        .href="${this.href}"
        actionname="update-user"
        successtext="User details have been updated."
        errortext="Failed to update user details."
        submittext="Update"
      >
        <span slot="header"></span>
      </bn-action>
    `;
  }
}

window.customElements.define('update-user', UpdateUser);
